export const baseUrl = process.env.REACT_APP_API_BASE_URL;
export const apiKey = process.env.REACT_APP_API_KEY as string;

export const userUrl = 'users';
export const brokerageAccountUrl = 'brokerage/account';
